export default "__VITE_ASSET__2cLc9kqh__"